import { Theme } from '@mui/material';
import { gradientBorder } from '../../../../../../themes/v2/theme.base';

export const TAB_GAP_PX = 6;

export const MORE_PILL_RESERVE_PX = 96;

export const MORE_PILL_ACTIVE_MAX_WIDTH_PX = 160;

export const TABS_WRAP_BREAKPOINT_PX = 1200;

export const TAB_SORT_TRANSITION = {
  duration: 180,
  easing: 'cubic-bezier(0.2, 0, 0, 1)',
};

export const ADD_TRIGGER_SX = (theme: Theme) => ({
  border: '1px solid transparent',
  '& svg': { strokeWidth: 1.25 },
  '&[data-active="true"]': {
    background: gradientBorder(
      theme.palette.secondary.dark,
      theme.palette.custom.gradients.secondaryButton,
    ),
  },
});
